import React, { FunctionComponent } from 'react'
import Dropzone from 'react-dropzone'
import filesize from 'filesize'

import document from '../assets/images/Icon-document.svg'
import upload from '../assets/images/icon-upload.svg'
import classnames from 'classnames'

export type Callback = (...args: any[]) => void

export interface Input {
  disabled: boolean
  name: string
  onChange: Callback
  value: any[]
}

export interface Meta {
  touched: boolean
  error: boolean
  dirty: boolean
  pristine: boolean
}

export interface Props {
  deleteFile: Callback
  input: Input
  meta: Meta
}

export const DropZoneInput: FunctionComponent<Props> = ({
  input,
  meta,
  deleteFile,
}) => {
  const onDrop = (filesToUpload) => {
    input.onChange(filesToUpload)
  }
  const files = input.value

  return (
    <div className="dropzone">
      <Dropzone
        name={input.name}
        onDrop={onDrop}
        data-testid="uploadButton"
        className={classnames('dropzone__area', {
          'dropzone__area--error': meta.touched && meta.error,
        })}
        disableClick={meta.dirty}
      >
        {meta.pristine ? (
          <div>
            <img alt="" src={upload} className="dropzone__area--icon" />
            <div className="dropzone__area--row">Drop to upload your files</div>
            <div className="dropzone__area--button">Select files to upload</div>
          </div>
        ) : null}

        {files && Array.isArray(files) && (
          <div>
            {files.map((file, i) => (
              <div key={i}>
                <img alt="" src={document} className="dropzone__area--icon" />
                <div className="dropzone__area--row">{file.name}</div>
                <div>({filesize(file.size)})</div>
                <div
                  data-test="deleteButton"
                  // disabled={input.disabled} TODO-TS
                  className="dropzone__area--button"
                  onClick={deleteFile}
                >
                  Delete
                </div>
              </div>
            ))}
          </div>
        )}
      </Dropzone>
      {meta.touched && meta.error && (
        <p className="form__help-text text-error">{meta.error}</p>
      )}
    </div>
  )
}

export default DropZoneInput

DropZoneInput.displayName = 'DropZoneInput'
